/** InsCoder WANG.J 2026-07-21 B + Ingredients carousel navigation, progress, and active CTA. **/
document.querySelectorAll('[data-ingredients-section]').forEach((section) => {
  const track = section.querySelector('[data-ingredients-track]');
  const slides = [...section.querySelectorAll('[data-ingredient-slide]')];
  const progress = section.querySelector('[data-ingredients-progress]');
  const cta = section.querySelector('[data-ingredients-button]');
  const prevButtons = [...section.querySelectorAll('[data-ingredients-prev]')];
  const nextButtons = [...section.querySelectorAll('[data-ingredients-next]')];
  let index = 0;

  if (!slides.length) return;

  const nearestIndex = () => slides.reduce((closest, slide, slideIndex) => {
    const distance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
    const closestDistance = Math.abs(slides[closest].offsetLeft - track.offsetLeft - track.scrollLeft);
    return distance < closestDistance ? slideIndex : closest;
  }, 0);
  const update = () => {
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === index);
      slide.querySelectorAll('.cust-community-ingredients__mobile-progress span').forEach((segment, segmentIndex) => {
        segment.classList.toggle('is-current', segmentIndex === index);
      });
    });
    if (progress) {
      const scrollProgress = (track.scrollLeft + track.clientWidth) / track.scrollWidth;
      progress.style.transform = `scaleX(${scrollProgress})`;
    }
    if (cta) {
      cta.textContent = slides[index].dataset.buttonLabel;
      cta.href = slides[index].dataset.buttonLink;
      cta.classList.toggle('is-hidden', !slides[index].dataset.buttonLabel);
    }
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    prevButtons.forEach((btn) => btn.classList.toggle('is-disabled', atStart));
    nextButtons.forEach((btn) => btn.classList.toggle('is-disabled', atEnd));
  };

  const go = (next) => {
    if (track.scrollWidth <= track.clientWidth + 1) {
      index = 0;
      update();
      return;
    }
    index = (next + slides.length) % slides.length;
    track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    update();
  };

  section.querySelectorAll('[data-ingredients-prev]').forEach((button) => {
    button.addEventListener('click', () => {
      if (button.classList.contains('is-disabled')) return;
      go(nearestIndex() - 1);
    });
  });
  section.querySelectorAll('[data-ingredients-next]').forEach((button) => {
    button.addEventListener('click', () => {
      if (button.classList.contains('is-disabled')) return;
      go(nearestIndex() + 1);
    });
  });
  track.addEventListener('scroll', () => {
    index = nearestIndex();
    update();
  }, { passive: true });
  window.addEventListener('resize', () => {
    index = nearestIndex();
    update();
  });
  update();
});
/** InsCoder WANG.J 2026-07-21 E + Ingredients carousel navigation, progress, and active CTA. **/
